<template>
<nav class="navbar navbar-expand-md fixed-top navbar-dark bg-dark" aria-label="Main navigation">

  <div class="navbar-collapse offcanvas-collapse" :class="{ 'open': topbarToggled }" id="topNavbar">

    <!-- Rechts ausgerichtete UL -->
    <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
      <li class="nav-item">
        <router-link to="/" class="nav-link">
          <span class="d-md-none d-xl-inline">Login</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link to="/" class="nav-link">
          <span class="d-md-none d-xl-inline">Demozugang</span>
        </router-link>
      </li>
    </ul>

  </div>

</nav>
</template>


<script>

</script>
<style>

</style>